export enum POSTHOG_EVENTS {
	// Authentication & User Management
	LOGIN_ATTEMPTED = "login_attempted",
	LOGIN_SUCCESSFUL = "login_successful",
	LOGIN_FAILED = "login_failed",
	USER_REGISTERED = "user_registered",
	LOGOUT = "logout",
	MFA_SETUP_STARTED = "mfa_setup_started",
	MFA_SETUP_COMPLETED = "mfa_setup_completed",
	MFA_SETUP_FAILED = "mfa_setup_failed",
	PASSWORD_RESET_REQUESTED = "password_reset_requested",

	// Organization Management
	ORGANIZATION_CREATED = "organization_created",
	ORGANIZATION_SELECTED = "organization_selected",
	ORGANIZATION_SWITCHED = "organization_switched",
	SUB_ORGANIZATION_CREATED = "sub_organization_created",
	USER_INVITED_TO_ORG = "user_invited_to_org",

	// Image Generation
	IMAGE_GENERATION_STARTED = "image_generation_started",
	IMAGE_GENERATION_COMPLETED = "image_generation_completed",
	IMAGE_GENERATION_FAILED = "image_generation_failed",

	// Image Editing
	IMAGE_EDITING_STARTED = "image_editing_started",
	IMAGE_EDITING_COMPLETED = "image_editing_completed",
	IMAGE_EDITING_FAILED = "image_editing_failed",



	// Tailored Generation (TG)
	TG_PROJECT_CREATED = "tg_project_created",
	TG_PROJECT_CREATION_FAILED = "tg_project_creation_failed",
	TG_MODEL_TRAINING_STARTED = "tg_model_training_started",
	TG_MODEL_TRAINING_COMPLETED = "tg_model_training_completed",
	TG_MODEL_TRAINING_FAILED = "tg_model_training_failed",
	TG_DATASET_UPLOADED = "tg_dataset_uploaded",
	TG_DATASET_UPLOAD_FAILED = "tg_dataset_upload_failed",

	// Product Placement
	PRODUCT_PLACEMENT_STARTED = "product_placement_started",
	PRODUCT_PLACEMENT_COMPLETED = "product_placement_completed",
	PRODUCT_PLACEMENT_FAILED = "product_placement_failed",

	// Design Editor & Campaigns
	AD_CREATION_STARTED = "ad_creation_started",
	AD_CREATION_COMPLETED = "ad_creation_completed",
	AD_CREATION_FAILED = "ad_creation_failed",
	CAMPAIGN_CREATED = "campaign_created",
	CAMPAIGN_CREATION_FAILED = "campaign_creation_failed",
	BRAND_TEMPLATE_CREATED = "brand_template_created",
	BRAND_TEMPLATE_CREATION_FAILED = "brand_template_creation_failed",
	TEMPLATE_CREATED = "template_created",
	TEMPLATE_CREATION_FAILED = "template_creation_failed",

	// Billing & Subscriptions
	SUBSCRIPTION_VIEWED = "subscription_viewed",
	SUBSCRIPTION_UPDATE_FAILED = "subscription_update_failed",
	USAGE_VIEWED = "usage_viewed",

	// Pricing & Sales
	PRICING_PAGE_VIEWED = "pricing_page_viewed",
	PLAN_COMPARISON_VIEWED = "plan_comparison_viewed",
	CONTACT_SALES_CLICKED = "contact_sales_clicked",

	// API & Documentation
	API_DOCUMENTATION_VIEWED = "api_documentation_viewed",
	API_KEY_GENERATED = "api_key_generated",
	API_KEY_GENERATION_FAILED = "api_key_generation_failed",

	// Generic Events
	ERROR_OCCURRED = "error_occurred",
	FEATURE_USED = "feature_used",
}
